import React from 'react'

import { ListItemAction } from '@interco/inter-toranja'
import type { TagProps } from '@interco/inter-toranja/dist/types/shared'
import { useActionHandler } from '@/hooks/useActionHandler'
import { useHomeCreditListItemTag } from '@/hooks/useHomeCreditListItemTag'

import * as S from './styles'

interface ListItemActionSDUIProps {
  items: ListItemActionData[]
  style?: { marginTop?: string; marginBottom?: string }
  componentAnalytics?: Analytics
}

export const ListItemActionSDUI: React.FC<ListItemActionSDUIProps> = ({
  items,
  style,
  componentAnalytics,
}) => {
  const { dispatchAction } = useActionHandler()
  const fireListItemTag = useHomeCreditListItemTag()

  return (
    <S.ContainerListItemDefault style={style}>
      {items.map((item) => {
        const baseProps = {
          label: item.title,
          paragraph: item.description,
          showDivider: item.showDivider === 'enabled',
          variant: (item.variant as 'inset') ?? 'inset',
          leadingProps:
            item.showLeading !== 'disabled' && item.icon
              ? {
                  iconProps: {
                    asset: item.icon as never,
                    color: 'Icon/Neutral/Primary' as const,
                    contentDescription: 'Icon',
                    size: 'medium' as const,
                  },
                  type: 'icon' as const,
                }
              : undefined,
          onTag: (tag: TagProps) => fireListItemTag(tag, item.title),
          onClick: () => dispatchAction(item.action, item.analytics ?? componentAnalytics),
        }

        if (item.trailingVariant === 'button' && item.trailingProps) {
          return (
            <ListItemAction
              key={item.id}
              {...baseProps}
              trailingVariant="button"
              trailingProps={{
                label: item.trailingProps.label ?? 'Ação',
                variant: item.trailingProps.variant ?? 'default',
                hierarchy: item.trailingProps.hierarchy ?? 'primary',
                size: item.trailingProps.size ?? 'small',
              }}
            />
          )
        }

        return <ListItemAction key={item.id} {...baseProps} />
      })}
    </S.ContainerListItemDefault>
  )
}
